import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set<() => void>();

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
};

const getSnapshot = () => open;

export const setDevPanelOpen = (next: boolean) => {
  if (open === next) return;
  open = next;
  listeners.forEach((l) => l());
};

export const toggleDevPanelOpen = () => setDevPanelOpen(!open);

export const useDevPanelOpen = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
